export default class Survey {
    constructor(name, signaturePadInstance) {
        window[name] = this.data(signaturePadInstance)

    }

    data(signaturePadInstance) {
        return {
            initialised: false,
            loading: true,
            toastDisplay: true,
            toastMessage: 'Bezig met laden...',
            successMessage: null,
            errorMessage: null,
            SubPlanId: null,
            SurverId: null,
            questions: {},
            values: {},
            FormType: null,
            questionCount: 0,
            showErrorToast: false,
            ValidationActive: false,
            requiredFields: [],
            contactPreferences: [],
            maxObjects: 1,
            contactPreferencesLoaded: false,
            ShouldShowToastMsg: false,
            formExpired: false,
            showZoom: null,
            isFirstTimeFilling: false,
            isUploading: false,

            //Signature
            signaturePadInstance: signaturePadInstance,
            signaturePad: null, // used to track the SignaturePad Instance
            signature: null, // variable to save the signature
            signature_agree: null,
            signature_place: null,
            signature_date: null,
            hasDrewSignature: false,
            orginSignature: null,
            hasSignatureError: false,

            Init(SubPlanId, Type, isExpired = false, projectUid, formUid) {
                window.hasErrors = []
                var vm = this;
                vm.SubPlanId = SubPlanId
                vm.FormType = Type
                vm.formExpired = isExpired
                vm.projectUid = projectUid
                vm.formUid = formUid
                var xhttp = new XMLHttpRequest();
                xhttp.onreadystatechange = function () {
                    if (this.readyState == 4 && this.status == 200) {
                        var responce = JSON.parse(this.responseText)
                        vm.questions = responce.Survey.questions
                        vm.SurverId = responce.Survey.uid,
                            vm.toastMessage = 'Succes!'
                        vm.loading = false
                        vm.initialised = true

                        // Set form values of fill with default value
                        // Default value is necessary for array items
                        var arrayTypeQuestions = ['multiple-choice', 'bsr', 'image-select']

                        vm.questions.map(function (question) {
                            var DefaultValue = arrayTypeQuestions.indexOf(question.type) ? '' : ''

                            if (!['header', 'paragraph', 'contact-details'].includes(question.type) && (question.data.meta?.not_required ?? false) === false) {
                                vm.requiredFields.push(question.uid)
                            }
                            if (question.type == 'contact-preferences') {
                                vm.maxObjects = question.data.meta.max_preferences;

                                if (typeof question.feedback === 'undefined' || question.feedback === null) {
                                    return;
                                }

                                var parsed = JSON.parse(question.feedback.answer);

                                if (parsed) {
                                    parsed.forEach(function (entry) {
                                        vm.addPreferenceItem(entry.object_id);
                                    });
                                    vm.setPreferenceValueToQuestion(question.uid, false);
                                }
                                return;

                            }
                            if (question.type == 'signature') {
                                if (typeof question.feedback === 'undefined' || question.feedback === null) {
                                    return;
                                }
                                setTimeout(function () {
                                    if (vm.signaturePad == null) {
                                        return;
                                    }
                                    // signature - date - place - agree
                                    var parsed = JSON.parse(question.feedback.answer);
                                    if (typeof parsed[0] !== 'undefined' && parsed[0] !== "") {
                                        // Has signature
                                        vm.signaturePad.fromDataURL(parsed[0]);
                                        vm.signaturePad.off();
                                        vm.orginSignature = parsed[0];
                                    }
                                    if (typeof parsed[1] !== 'undefined' && parsed[1] !== "") {
                                        vm.signature_date = parsed[1];
                                    }
                                    if (typeof parsed[2] !== 'undefined' && parsed[2] !== "") {
                                        vm.signature_place = parsed[2];
                                    }
                                    if (typeof parsed[3] !== 'undefined' && parsed[3] !== "") {
                                        vm.signature_agree = parsed[3];
                                    }
                                }, 300)

                                vm.values[question.uid] = JSON.parse(question.feedback.answer);
                                return;
                            }

                            vm.values[question.uid] = question.feedback ? vm.parseValue(question.uid, question.feedback.answer) : DefaultValue
                        })

                        setTimeout(function () {
                            vm.initSignature();
                            window.addEventListener("resize", vm.resizeCanvas(vm));
                            vm.resizeCanvas(vm);
                        }, 100)
                    }
                }
                xhttp.open('post', '/woonmens/api/get-' + vm.FormType + '/', true);
                xhttp.setRequestHeader('Content-type', 'application/json;charset=utf-8');
                setTimeout(function () {
                    xhttp.send(JSON.stringify({
                        'sub_plan_id': SubPlanId
                    }));
                }, 500)
            },
            SubmitBtnClick() {
                this.ValidationActive = true;
                this.Submit(true)
            },
            Submit(ShowToastMsg = false) {

                var vm = this
                vm.resetErrors();

                if (vm.loading === true) {
                    return;
                }

                vm.loading = true
                vm.showErrorToast = false;
                vm.toastDisplay = false

                vm.ShouldShowToastMsg = ShowToastMsg

                // vm.ValidationActive = true;
                var xhttp = new XMLHttpRequest();

                xhttp.open('post', '/woonmens/api/update-' + vm.FormType, true);
                xhttp.onreadystatechange = function () {


                    if (this.readyState == 4 && this.status == 200) {
                        var response = JSON.parse(this.responseText);
                        if (typeof (response.validation) !== 'undefined') {
                            vm.showErrorToast = true;
                            vm.loading = false
                            return vm.ValidationResponse(response.validation);
                        }

                        if (response.isFirstTimeFilling == true) {
                            vm.isFirstTimeFilling = true;
                        }
                        setTimeout(function () {
                            if (!vm.showErrorToast && ShowToastMsg == true) {
                                if (vm.FormType == 'optionform') {
                                    if (vm.isFirstTimeFilling) {
                                        window.dataLayer.push({
                                            'event': 'optieformulier-gelukt'
                                        });

                                        return window.location.assign('/account/' + vm.SubPlanId + '/optieformulier/gelukt');
                                    } else {
                                        window.dataLayer.push({
                                            'event': 'optieformulier-gewijzigd'
                                        });

                                        return window.location.assign('/account/' + vm.SubPlanId + '/optieformulier/gewijzigd');
                                    }
                                }

                                if (vm.isFirstTimeFilling) {
                                    window.dataLayer.push({
                                        'event': 'enquete-gelukt'
                                    });

                                    return window.location.assign('/account/' + vm.SubPlanId + '/enquete/gelukt');
                                } else {
                                    window.dataLayer.push({
                                        'event': 'enquete-gewijzigd'
                                    });

                                    return window.location.assign('/account/' + vm.SubPlanId + '/enquete/gewijzigd');
                                }
                            }
                        }, 300)
                        setTimeout(function () {
                            vm.loading = false
                            vm.successMessage = null
                        }, 1000)
                    }
                }

                // Remove empty values before submitting
                var values = {}
                var bodyFormData = new FormData()

                // console.log(vm.questions);
                Object.keys(vm.questions).map(function (index) {
                    var uid = vm.questions[index].uid
                    delete window.hasErrors[uid];

                    if (vm.questions[index].type == 'contact-preferences') {
                        if (vm.values[uid] != '') {
                            values[uid] = vm.values[uid]
                        }

                        if (ShowToastMsg && vm.requiredFields.indexOf(uid) != -1 && vm.values[uid] == null && vm.checkConditionals(index)) {
                            window.hasErrors[uid] = true
                            return true
                        }
                    } else if (vm.questions[index].type == 'date') {
                        const date = new Date(vm.values[uid]);

                        if (date instanceof Date && !isNaN(date) === false) {
                            window.hasErrors[uid] = true;
                            return true;
                        } else {
                            values[uid] = [vm.values[uid]]
                        }
                    } else if (vm.questions[index].type == 'upload') {
                        if (vm.requiredFields.indexOf(uid) != -1 && vm.values[uid] == '' && vm.checkConditionals(index) && ShowToastMsg) {
                            window.hasErrors[uid] = true
                        } else if (vm.values[uid] != '') {
                            values[uid] = [vm.values[uid]]
                        }
                    } else if (vm.questions[index].type == 'signature') {
                        if (vm.hasFilledAllSignatureFields(ShowToastMsg)) {
                            values[uid] = vm.values[uid]
                        }
                    } else if (!['header', 'paragraph', 'contact-details'].includes(vm.questions[index].type) && (vm.questions[index].data.meta?.not_required ?? true) === false && vm.values[uid] === '') {
                        window.hasErrors[uid] = true;
                    } else if (vm.values[uid] != '') {
                        values[uid] = vm.splitValue(vm.values[uid])
                    } else if (ShowToastMsg && vm.requiredFields.indexOf(uid) != -1 && vm.values[uid] == '' && vm.checkConditionals(index)) {
                        window.hasErrors[uid] = true
                        return true
                    }
                });
                setTimeout(() => {
                    if (Object.keys(window.hasErrors).length) {
                        const failedQuestions = Object.keys(vm.questions)
                            .filter(index => typeof window.hasErrors[vm.questions[index].uid] !== 'undefined')
                            .map(index => {
                                const question = vm.questions[index];

                                return {
                                    uid: question.uid,
                                    type: question.type,
                                    question: question.question ?? question.data?.question ?? question.data?.title ?? question.data?.label ?? question.data?.text,
                                    value: vm.values[question.uid],
                                    error: window.hasErrors[question.uid],
                                };
                            });

                        console.table(failedQuestions);

                        if (ShowToastMsg) {
                            vm.showErrorToast = true;
                        }
                        vm.loading = false;
                        let firstElementWithError = null;

                        // add class to every invalid fields
                        Object.keys(window.hasErrors).forEach(key => {
                            const elementWithError = document.getElementById(key);
                            if (elementWithError) {
                                /*
                                 * get the form-control class
                                 * we filter on this instead of all types of input, textarea etc
                                 */
                                const formControl = elementWithError.getElementsByClassName('form-control')[0] ?? false;

                                if (formControl !== false) {
                                    if (firstElementWithError === null) {
                                        firstElementWithError = elementWithError;
                                    }

                                    formControl.classList.add('has-errors');
                                }
                            }
                        });

                        /*
                         * jump to first element (only when we use the SubmitBtnClick which triggers ShowToastMsg)
                         */
                        if (firstElementWithError !== null && ShowToastMsg === true) {
                            vm.scrollTo(firstElementWithError);
                        }

                        // we don't send our data as below in bodyFormData
                        return;
                    }

                    bodyFormData.append('form_id', vm.SurverId);
                    bodyFormData.append('values', JSON.stringify(values));

                    xhttp.send(bodyFormData);
                }, 100)
            },
            hasError(uid, questionIndex) {
                var vm = this
                if (!vm.ValidationActive) return

                if (typeof (window.hasErrors[uid]) !== 'undefined') {
                    return true;
                }

                if (vm.checkMinMax(questionIndex)) {
                    window.hasErrors[uid] = true
                    return true
                }

                if (vm.requiredFields.indexOf(uid) != -1 && vm.values[uid] == '' && vm.checkConditionals(questionIndex)) {
                    window.hasErrors[uid] = true
                    return true
                }

                delete window.hasErrors[uid]
            },
            parseValue(questionUid, Answer) {
                return JSON.parse(Answer).join('||');
            },
            splitValue(value) {
                return value.split('||')
            },
            checkConditionalsOrOr(questionUid) {
                var vm = this;

                // Check if question data is presented
                if (!vm.questions[questionUid].data.conditional || typeof vm.questions[questionUid].data.conditional != 'object') {
                    return true
                }

                var MeetsConditions = Object.keys(vm.questions[questionUid].data.conditional).map(function (key) {
                    var kk = vm.questions[questionUid].data.conditional[key]
                    var items = vm.values[kk.question_id].split('||')
                    var idx = items.indexOf(kk.question_value)
                    if (idx === -1) {
                        delete window.hasErrors[vm.questions[questionUid].uid]
                        return false
                    }
                    return true
                })

                for (var ConditionIndex in MeetsConditions) {
                    if (MeetsConditions[ConditionIndex]) {
                        return true;
                    }
                }

                // We should not display it empty question and delete
                if (vm.values[vm.questions[questionUid].uid] != '') {
                    vm.values[vm.questions[questionUid].uid] = ''
                }
                delete window.hasErrors[vm.questions[questionUid].uid]
                return false;
            },
            checkConditionals(questionUid) {
                var vm = this;

                // Check if question data is presented
                if (!vm.questions[questionUid].data.conditional || typeof vm.questions[questionUid].data.conditional != 'object') {
                    return true
                }

                // Check if we have or or
                if (vm.questions[questionUid].data.meta.is_conditional_or_or || typeof vm.questions[questionUid].data.meta.is_conditional_or_or == 'object') {
                    return vm.checkConditionalsOrOr(questionUid);
                }


                // Walk tru questions and check current selections
                // return true is value is selected
                var MeetsConditions = Object.keys(vm.questions[questionUid].data.conditional).map(function (key) {
                    var kk = vm.questions[questionUid].data.conditional[key]
                    var items = vm.values[kk.question_id].split('||')
                    var idx = items.indexOf(kk.question_value)
                    if (idx === -1) {
                        delete window.hasErrors[vm.questions[questionUid].uid]
                        return false
                    }
                    return true
                })

                // Check if there are any false values
                // And when there is return false, so given question will not be displayed in browser
                // Also empty question value (once) when it does not meet condition(s)
                for (var ConditionIndex in MeetsConditions) {
                    if (!MeetsConditions[ConditionIndex]) {
                        if (vm.values[vm.questions[questionUid].uid] != '') {
                            vm.values[vm.questions[questionUid].uid] = ''
                        }
                        delete window.hasErrors[vm.questions[questionUid].uid]
                        return false;
                    }
                }

                // When all conditions are valid then return true so question wil show up in browser
                return true;
            },
            toggleCheckboxValue(questionUid, Value = null, questionIndex, e) {
                var vm = this;

                var items = vm.values[questionUid].split('||');

                var idx = items.indexOf(Value);
                if (idx !== -1) {
                    items.splice(idx, 1);
                } else {
                    if (vm.checkIfMaxAnswer(vm.questions[questionIndex], items)) {
                        if (e) {
                            e.target.checked = false;
                        }

                        window.hasErrors[questionUid] = true
                        return false
                    }
                    items.push(Value);
                }

                // Remove empty values and rejoin to comma separated string
                vm.values[questionUid] = items.filter(function (el) {
                    return el != null;
                }).filter(function (el) {
                    return !Number.isNaN(el);
                }).join('||');

                vm.Submit(false);
            },
            getCheckboxValue(questionUid, Value) {
                // console.log( questionUid, Value )
                Value = Value.toString()

                // console.log(Value)
                var vm = this
                if (vm.values[questionUid]) {
                    var idx = vm.values[questionUid].split('||').indexOf(Value);
                    if (idx !== -1) {
                        return true
                    } else {
                        return false
                    }
                }
            },
            toggleRadioValue(questionUid, Value) {
                var vm = this
                vm.values[questionUid] = Value.toString();
                vm.Submit(false);
            },
            getRadioValue(questionUid, Value) {
                var vm = this
                // if (! vm.values[questionUid]) return false
                // console.log( (vm.values[questionUid] == Value.toString()) )
                return (vm.values[questionUid] == Value.toString())

            },
            checkMinMax(questionIndex) {
                var vm = this

                var question = vm.questions[questionIndex];

                // We do not deal with a min / max or it is not set
                if (!question.data.meta.min || !question.data.meta.max) {
                    return false
                }

                var items = vm.values[question.uid].split('||').filter(Boolean);
                console.log(items);
                if (items.length >= question.data.meta.min && items.length <= question.data.meta.max) {
                    // It is between5
                    return false;
                }
                // It is too much or too less
                return true;
            },
            checkIfMaxAnswer(question, items) {
                var vm = this;

                // We do not deal with a  max or it is not set
                if (!question.data.meta.max) {
                    return false
                }

                console.log(items);
                items = items.filter(Boolean);
                if (question.data.meta.max == 1 && items.length == 0) {
                    return false;
                }

                if (items.length >= question.data.meta.max) {
                    vm.makeErrorMessage(question.uid, "Maximum geselecteerd");
                    return true;
                }

                return false;
            },
            makeErrorMessage(Uid, message) {
                var vm = this;
                var el = document.getElementById(Uid);
                if (el) {
                    window.hasErrors[Uid] = true
                    var errorDiv = document.createElement('div');
                    errorDiv.innerHTML = message
                    errorDiv.className = 'text-red-500 font-bold text-left block left-0 p-3'
                    el.appendChild(errorDiv)
                    setTimeout(function () {
                        el.removeChild(errorDiv)
                    }, 2000);
                }
            },
            ValidationResponse(ValidationResponse) {
                var vm = this;
                if (typeof (ValidationResponse) !== 'undefined') {
                    if (typeof (ValidationResponse.answers[0][0]) !== 'undefined') {
                        var errorString = ValidationResponse.answers[0][0];
                        var res = errorString.split("|");
                        var el = document.getElementById(res[0]);
                        if (el) {
                            window.hasErrors[res[0]] = true
                            var errorDiv = document.createElement('div');
                            errorDiv.innerHTML = res[1]
                            errorDiv.className = 'woonmens-validation-message text-red-500 pt-4 text-right absolute right-0 pr-3'
                            el.appendChild(errorDiv)
                            vm.scrollTo(el);
                        }
                    }
                }
            },
            scrollTo(targetEle) {
                if (!this.ShouldShowToastMsg) {
                    return;
                }
                const pos = targetEle.style.position;
                const top = targetEle.style.top;
                targetEle.style.position = 'relative';
                targetEle.style.top = '-200px';
                targetEle.scrollIntoView({behavior: 'smooth', block: 'start'});
                targetEle.style.top = top;
                targetEle.style.position = pos;
            },
            resetErrors() {
                window.hasErrors = []
                this.showErrorToast = false;
                document.querySelectorAll('.woonmens-validation-message').forEach(el => {
                    if (el) el.remove();
                });
                document.querySelectorAll('.has-errors').forEach(el => {
                    if (el) el.classList.remove('has-errors')
                });
            },
            // CONTACT PREFERENCES METHOD:
            getContactPreferences() {
                if (this.contactPreferences.length >= 1) {
                    return this.contactPreferences
                }

                this.contactPreferences.push({
                    object_id: '',
                    index: this.contactPreferences.length + 1
                })
                return this.contactPreferences
            },
            setPreferenceText(index) {
                //TODO max objextpreferences
                var Preferences = [];

                for (var i = 1; i <= this.maxObjects; i++) {
                    Preferences.push(i + 'ᵉ voorkeur');
                }

                return Preferences[index]
            },
            canAddPreferenceItem() {
                if (this.hasMaxPreferences()) {
                    return false;
                }
                return true;
            },
            addPreferenceItem(object_id = '') {
                if (this.hasMaxPreferences()) {
                    return;
                }
                this.contactPreferences.push({
                    object_id: object_id,
                    index: this.contactPreferences.length + 1
                })
            },
            hasMaxPreferences() {
                if (this.contactPreferences.length && this.contactPreferences.length >= this.maxObjects) return true;
                if (this.contactPreferences.length && this.contactPreferences[this.contactPreferences.length - 1].object_id == '') return true;
                return false
            },
            removePreferenceItem(Index, questionUid) {
                delete this.contactPreferences[Index];
                this.contactPreferences = this.contactPreferences.filter(function (el, index) {
                    if (index == 0) {
                        index = 1;
                    }
                    el.index = index
                    return el.object_id != '';
                });
                this.setPreferenceValueToQuestion(questionUid);
            },
            setPreferenceValueToQuestion(questionUid, autoSubmit = true) {
                this.values[questionUid] = this.contactPreferences;
                if (autoSubmit) {
                    this.Submit()
                }
            },
            isSelected(UniqueId) {
                for (var element of this.contactPreferences)
                    if (element['object_id'] == UniqueId)
                        return false;

                return true
            },
            swap(direction, arrayIndex, questionUid) {
                if ('up' == direction) {
                    this.switchPlaces(arrayIndex, arrayIndex - 1);
                } else {
                    this.switchPlaces(arrayIndex, arrayIndex + 1);
                }

                this.setPreferenceValueToQuestion(questionUid);
            },
            switchPlaces(a, b) {
                const input = this.clone(this.contactPreferences)
                const output = this.clone(this.contactPreferences);
                if (typeof input[b] === 'undefined') {
                    return;
                }

                // output[a].object_name = input[b].object_name
                output[a].object_id = input[b].object_id

                // output[b].object_name = input[a].object_name
                output[b].object_id = input[a].object_id
                this.contactPreferences = [];

                var index = 1;
                var vm = this;
                output.forEach(function (entry) {
                    vm.addPreferenceItem(entry.object_id);
                });
            },
            clone(obj) {
                if (obj == null || typeof (obj) != 'object')
                    return obj;
                var temp = new obj.constructor();
                for (var key in obj)
                    temp[key] = this.clone(obj[key]);
                return temp;
            },
            getOnlySourceUrl(url) {
                if (!url) {
                    return;
                }
                return "/woonmens/api/show-file/" + encodeURIComponent(window.btoa(url));
            },
            getSourceUrl(url) {
                if (!url) {
                    return;
                }
                return window.open("/woonmens/api/show-file/" + encodeURIComponent(window.btoa(url)), '_blank');
            },
            isUsingOldUploadWay(value) {
                if (this.isValidHttpUrl(value)) {
                    return true;
                }
                return false;
            },
            getOldSourceUrl(value) {
                console.log(value);
                return this.getOnlySourceUrl(value);
            },
            isValidHttpUrl(string) {
                let url;

                try {
                    url = new URL(string);
                } catch (_) {
                    return false;
                }

                return url.protocol === "http:" || url.protocol === "https:";
            },
            isNumber(event) {
                var charCode = (event.which) ? event.which : event.keyCode;

                // Backspace -  enter - delete
                if (charCode == 8 || charCode == 13 || charCode == 46) return true;

                //48 => 0 , 57 => 9 ,  96 => numpad 0 , 105 => numpad 9
                if ((charCode < 48 || charCode > 57) && (charCode < 96 || charCode > 105)) return false;

                return true;
            },
            UploadFile(Event, questionUid) {
                var vm = this;
                var oldValue = vm.values[questionUid];
                vm.isUploading = true;
                delete vm.values[questionUid];
                vm.resetErrors();
                var fileInput = Event.target;
                var progress = vm.$refs['progress_' + questionUid];
                const config = {
                    onUploadProgress: function (progressEvent) {
                        progress.value = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                    }
                }

                var bodyFormData = new FormData();

                bodyFormData.append('file', fileInput.files[0]);
                bodyFormData.append('questionUid', questionUid);
                bodyFormData.append('subPlanUid', vm.SubPlanId);
                bodyFormData.append('projectUid', vm.projectUid);
                bodyFormData.append('formUid', vm.formUid);


                window.axios.post('/woonmens/api/files/upload/', bodyFormData, config)
                    .then(response => {
                        if (response.data) {
                            progress.value = 0;
                            vm.isUploading = false;

                            if (response.data.status == 'ok') {
                                vm.values[questionUid] = response.data.id;
                                fileInput.value = ''
                                vm.Submit(false);
                            } else {
                                window.hasErrors[questionUid] = true;
                                vm.values[questionUid] = oldValue;
                                var errorDiv = document.createElement('div');
                                errorDiv.innerHTML = response.data.message
                                errorDiv.className = 'woonmens-validation-message text-red-500 pt-4 text-right absolute right-0 pr-3'
                                fileInput.parentElement.appendChild(errorDiv)

                            }
                        }
                    })
            },
            addBlankTarget(input) {
                return input.split('<a').join('<a target="_blank"')
            },
            initSignature() {
                var vm = this;
                if (this.$refs.canvas == null) {
                    return;
                }
                this.signaturePad = new this.signaturePadInstance(this.$refs.canvas, {
                    // minWidth: 5,
                    // maxWidth: 10,
                    // penColor: "rgb(66, 133, 244)"
                });// initialize the canvas with Signature pad


                this.signaturePad.addEventListener("beginStroke", () => {
                    vm.hasDrewSignature = true;
                }, {once: true});
            },
            signatureSave(questionUid) {
                if (!this.hasFilledAllSignatureFields(true)) {
                    return;
                }

                const signature = this.hasDrewSignature ? this.signaturePad.toDataURL("image/svg+xml") : this.orginSignature;

                this.values[questionUid] = [signature, this.signature_date, this.signature_place, this.signature_agree]

                this.ValidationActive = true;

                this.Submit(true)
            },
            signatureClear() {
                this.signaturePad.clear(); // clear the signature pad
                this.signaturePad.on();
                this.orginSignature = null;
            },
            resizeCanvas(vm) {
                if (this.$refs.canvas == null) {
                    return;
                }
                const ratio = Math.max(window.devicePixelRatio || 1, 1);
                vm.$refs.canvas.width = vm.$refs.canvas.offsetWidth * ratio;
                vm.$refs.canvas.height = vm.$refs.canvas.offsetHeight * ratio;
                vm.$refs.canvas.getContext("2d").scale(ratio, ratio);
                vm.signaturePad.clear(); // otherwise isEmpty() might return incorrect value
            },
            hasFilledAllSignatureFields(showErrror = true) {
                let hasFilledAllFields = true;

                if (this.signaturePad.isEmpty()) {
                    if (showErrror) {
                        this.hasSignatureError = true;
                    }
                    hasFilledAllFields = false;
                }
                if (!this.signature_agree) {
                    if (showErrror) {
                        this.makeSignatureError('Is verplicht', this.$refs.signature_agree)
                    }
                    hasFilledAllFields = false;
                }

                if (!this.signature_date) {
                    if (showErrror) {
                        this.makeSignatureError('Is verplicht', this.$refs.signature_date)
                    }
                    hasFilledAllFields = false;
                }

                if (!this.signature_place) {
                    if (showErrror) {
                        this.makeSignatureError('Is verplicht', this.$refs.signature_place)
                    }
                    hasFilledAllFields = false;
                }

                return hasFilledAllFields;
            },
            makeSignatureError(message, element) {
                var vm = this;

                var errorDiv = document.createElement('div');
                errorDiv.innerHTML = message
                errorDiv.className = 'woonmens-validation-message text-red-500 pt-4 text-right absolute right-0 pr-3'
                element.parentElement.appendChild(errorDiv)
                setTimeout(function () {
                    errorDiv.remove();
                    vm.hasSignatureError = false;
                }, 2000)
            },
        }
    }
}
